<template>
  <div class="login">
    <div class="login_mode">
      <ul>
        <li @click="changeTab(1)" :class="{ active: currentTab === 1 }">
          {{ this.$al.login.codeLogin }}
        </li>
        <li @click="changeTab(2)" :class="{ active: currentTab === 2 }">
          {{ this.$al.login.accountLogin }}
        </li>
      </ul>
      <div>
        <div class="box" v-if="currentTab === 1">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item prop="tel">
              <el-input
                :placeholder="this.$al.login.inputPhone"
                v-model="ruleForm.tel"
                class="phone"
              ></el-input>
            </el-form-item>
            <el-form-item prop="sms">
              <el-input
                :placeholder="this.$al.login.inputCode"
                autocomplete="off"
                v-model="ruleForm.sms"
                class="mtb sms password"
              >
                <el-button
                  slot="append"
                  @click="sendSms()"
                  :disabled="!show"
                  class="code-btn"
                >
                  <span v-show="show">{{ this.$al.login.getCode }}</span>
                  <span v-show="!show" class="count">{{ count }}</span>
                </el-button>
              </el-input>
            </el-form-item>
            <el-form-item style="margin-top: 50px">
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                class="logbtn"
                style="width: 100%"
              >{{ this.$al.login.login }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-else class="box">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item prop="username">
              <el-input
                :placeholder="this.$al.login.inputPhone"
                v-model="ruleForm.username"
                class="phone"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password" class="eye">
              <el-input
                :type="flag ? 'text' : 'password'"
                :placeholder="this.$al.login.inputPassword"
                v-model="ruleForm.password"
                class="mtb password"
              >
                <img v-show="flag" slot="append" src="../assets/imgs/login/image_eye.png" @click="flag = !flag"
                     style="width: 30px;" alt="img-eye"/>
                <img v-show="!flag" slot="append" src="../assets/imgs/login/image_eye_closed.png" @click="flag = !flag"
                     style="width: 30px;" alt="img-eye-closed"/>
              </el-input>
            </el-form-item>
            <el-form-item style="margin-top: 50px">
              <el-button
                type="primary"
                @click="submitFormUser('ruleForm')"
                style="width: 100%"
                class="logbtn"
              >{{ this.$al.login.login }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 隐私协议 -->
    <div style="text-align: center">
      <p class="agree">
        <span>{{ this.$al.login.loginAgreement }}</span>
        <span style="color: #409eff" @click="toAgreement">
          {{this.$al.login.agreement}}
        </span>
        <span>{{ this.$al.login.and }}</span>
        <span style="color: #409eff" @click="toPrivacy">
          {{this.$al.login.policy}}
        </span>
      </p>
    </div>

    <!--隐私政策-->
    <el-dialog
      title=""
      custom-class="privacy"
      append-to-body
      :visible.sync="privacySee"
      top="10vh"
      :center="true"
      :show-close="false"
    >
      <iframe
        style="width: 100%; height: 500px; border: none"
        :src="websiteBaseUrl + this.$al.login.privacyPolicyUrl"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="privacySee = false">
          {{this.$al.login.close}}
        </el-button>
      </span>
    </el-dialog>
    
    <!--用户协议-->
    <el-dialog
      title=""
      custom-class="privacy"
      append-to-body
      :visible.sync="agreementSee"
      top="10vh"
      :center="true"
      :show-close="false"
    >
      <iframe
        style="width: 100%; height: 500px; border: none"
        :src="websiteBaseUrl + this.$al.login.userAgreementUrl"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreementSee = false">
          {{this.$al.login.close}}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import axios from "../utils/http.js";
  import wxlogin from "vue-wxlogin";

  export default {
    components: {
      wxlogin,
    },
    data() {
      return {
        wxPCshow: true,
        flag: false,
        websiteBaseUrl: window.SITE_CONFIG.websiteBaseUrl,
        WeChat: {//微信参数
          appid: window.SITE_CONFIG.appid,
          redirect_uri: window.SITE_CONFIG.redirect_uri,
          scope: "snsapi_login",
          state: "",
        },
        wxloginpage: false,
        typePwd: "password",
        currentTab: 1,
        ruleForm: {
          tel: "",
          sms: "",
          username: "",
          password: "",
        },
        show: true,
        count: "60",
        rules: {
          tel: [
            {required: true, message: this.$al.login.inputPhone, trigger: "blur"},
            {min: 6, max: 50, message: this.$al.login.charactersLong, trigger: "blur"},
          ],
          sms: [{required: true, message: this.$al.login.inputCode, trigger: "blur"}],
          username: [{required: true, message: this.$al.login.inputAccount, trigger: "blur"}],
          password: [{required: true, message: this.$al.login.inputPassword, trigger: "blur"}],
        },
        privacySee: false,
        agreementSee: false,
      };
    },
    created() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (!flag) {
        this.wxPCshow = true
      } else {
        this.wxPCshow = false
      }
    },
    methods: {
      //隐私政策
      toPrivacy() {
        this.privacySee = true;
      },
      //用户协议
      toAgreement() {
        this.agreementSee = true;
      },

      //账号登录
      submitFormUser(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios
              .post("/api/v1/pc/pclogin", {
                account: this.ruleForm.username,
                password: this.$md5(this.ruleForm.password),
                source: 3,
              })
              .then((res) => {
                if (res.data.code === 0) {
                  //cookies保存token; localStorage保存用户信息
                  this.$cookies.set("token", res.data.data.token);
                  this.$emit('loginClick', {isLogin: true, userInfo: res.data.data});
                  this.$router.go(0)
                } else if (res.data.code == 117) {
                  this.$message.error(res.data.result);
                }
              })
          } else {
            return false;
          }
        });
      },
      //验证码登录
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios
              .post("/api/v1/pc/checkcode", {
                account: this.ruleForm.tel,
                code: this.ruleForm.sms,
                source: 3,
              })
              .then((res) => {
                if (res.data.code === 0) {
                  //cookies保存token; localStorage保存用户信息
                  this.$cookies.set("token", res.data.data.token);
                  this.$emit('loginClick', {isLogin: true, userInfo: res.data.data});
                  this.$router.go(0)
                } else if (res.data.code === 123) {
                  this.$message.error(this.$al.login.codeError);
                } else if (res.data.code === 118) {
                  this.$message.error(this.$al.login.accountError);
                }
              })
          } else {
            return false;
          }
        });
      },
      //获取验证码
      sendSms() {
        this.$refs.ruleForm.validateField("tel", (telError) => {
          if (!telError) {
            axios
              .post("/api/v1/pc/sendCommonCode", {
                account: this.ruleForm.tel,
              })
              .then((res) => {
                if (res.data.code === 0) {
                  this.validateBtn();
                }
              });
          }
        });
      },
      //验证码倒计时
      validateBtn() {
        //倒计时
        this.show = false;
        if (!this.timer) {
          this.count = 60;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= 60) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
              this.count = 60;
            }
          }, 1000);
        }
      },
      //密码显示隐藏
      showPwd() {
        this.typePwd = this.typePwd === "password" ? "text" : "password";
      },
      //切换登录方式
      changeTab(num) {
        this.currentTab = num;
      },
    }
  };
</script>

<style scoped>
  .loginP {
    position: absolute;
    top: -48px;
    left: 0;
    width: 100%;
    height: 588px;
    background: #fff;
  }

  .closewxlogin {
    font-size: 20px;
    color: #aeaeae;
    text-align: right;
    display: block;
  }

  .ewm {
    margin-top: 48px;
    display: flex;
    justify-content: center;
  }

  .agree {
    position: absolute;
    bottom: 0;
    left: 10%;
    right: 10%;
  }

  .box {
    width: 80%;
    margin: 2% auto;
  }

  .login {
    height: 560px;
    width: 100%;
    position: relative;
  }

  .loginP {
    position: absolute;
    top: -48px;
    left: 0;
    width: 100%;
    height: 588px;
    background: #fff;
  }

  .closewxlogin {
    font-size: 20px;
    color: #aeaeae;
    text-align: right;
    display: block;
  }

  .login .login_mode ul {
    padding: 8% 0;
    display: flex;
  }

  .login .login_mode ul li {
    padding-bottom: 5px;
    margin-left: 10%;
    font-size: 20px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN,serif;
    font-weight: bold;
    color: #262626;
    line-height: 30px;
  }

  .active {
    border-bottom: 0.2rem solid #007cff;
    color: #262626;
    font-weight: 700;
  }

  .threeLogin {
    display: flex;
    width: 80%;
    margin: 10px auto 0;
    align-items: center;
    justify-content: space-between;
  }

  .threeLogin i {
    height: 1px;
    background: #f0f0f0;
    flex: 1;
  }

  .threeLogin span {
    width: 100px;
    height: 16px;
    font-size: 12px;
    color: #aaaaaa;
    text-align: center;
  }

  .wxIcon {
    display: block;
    margin: 15px auto 15px;
  }

  .loginP >>> .el-dialog__header {
    padding: 0;
  }
</style>
<style>
.privacy{
  width: 1000px;
}
@media (max-width: 1000px) {
.privacy{
  width: 100%;
}
}
  .phone .el-input__inner {
    background: url("../assets/imgs/login/phone.png") no-repeat 10px center !important;
    padding: 30px 50px;
    border-bottom: 1px solid #f1f1f1;
    border-left: none;
    border-right: none;
    border-top: none;
    font-size: 15px;
    color: #aaa;
    border-radius: 0;
  }

  .eye .el-input-group__append {
    background: none;
    border-bottom: 1px solid #f1f1f1;
    border-left: none;
    border-right: none;
    border-top: none;
    width: 20px;
  }

  .eye .el-input-group__append .eyeimg {
    width: 20px;
  }

  .mtb {
    margin: 10px 0;
  }

  .password .el-input__inner {
    background: url("../assets/imgs/login/password.png") no-repeat 10px
    center !important;
    padding: 30px 50px; /*输入内容左右边距控制*/
    border-bottom: 1px solid #f1f1f1;
    border-left: none;
    border-right: none;
    border-top: none;
    font-size: 15px;
    color: #aaa;
    border-radius: 0;
  }

  .logbtn {
    background: #3544c4;
    height: 50px;
  }

  .logbtn:hover {
    background: #3544c4;
  }

  .sms .el-input-group__append {
    padding: 0 !important;
    background: none;
    border-bottom: 1px solid #f1f1f1;
    border-left: none;
    border-right: none;
    border-top: none;
  }

  .code-btn span {
    font-size: 17px;
  }
  .applylogin {
    font-size: 24px;
    text-align: center;
    margin: 50px 0;
  }
  /*包含以下五种的链接*/
  a {
    text-decoration: none;
  }
  /*正常的未被访问过的链接*/
  a:link {
    text-decoration: none;
  }
  /*已经访问过的链接*/
  a:visited {
    text-decoration: none;
  }
  /*鼠标划过(停留)的链接*/
  a:hover {
    text-decoration: none;
  }
  /* 正在点击的链接，鼠标在元素上按下还没有松开*/
  a:active {
    text-decoration: none;
  }
  /* 获得焦点的时候 鼠标松开时显示的颜色*/
  a:focus {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue